var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"q-app"}},[_c('transition',{attrs:{"appear":"","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.appReady)?_c('router-view'):_vm._e()],1),(_vm.showLoadingOverlay)?_c('LoadingOverlay'):_vm._e(),_c('NetworkConnectivityBanner'),_c('PermissionsWrapper')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }